<template>
  <div class="cursor-pointer tooltip-container" @mouseover="showTooltip" @mouseleave="hideTooltip">
    <slot></slot>
    <Transition name="tooltip">
      <div v-if="visible" class="tooltip-content" :style="{ left: posX, top: posY }">
        <span>{{ text }}</span>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue';

defineProps({
  text: {
    type: String,
    required: true
  }
});

const visible = ref(false);
const posX = ref('0px');
const posY = ref('0px');

function showTooltip(event) {
  visible.value = true;
  posX.value = `${(event.clientX / 100) + 10}px`;
  posY.value = `${(event.clientY / 100) + 10}px`;
}

function hideTooltip() {
  visible.value = false;
}
</script>

<style lang="scss">
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-content {
  position: absolute;
  width: max-content;
  z-index: 1000;
  background: #333;
  color: #fff;
  padding: 5px;
  border-radius: 3px;
  font-size: 14px;
  pointer-events: none;
}

.tooltip-enter-active,
.tooltip-leave-active {
  transition: opacity 0.2s ease;
}

.tooltip-enter-from,
.tooltip-leave-to {
  opacity: 0;
}
</style>
